import React from 'react'
import styles from './styles.module.scss'
import responsiveStyles from './responsiveStyles.module.scss'

// Icon components
const ServiceBadgeIcon = () => (
    <div className={styles.iconCircle}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            <polyline points="9 12 11 14 15 10"></polyline>
        </svg>
    </div>
)

const FinanceIcon = () => (
    <div className={styles.iconCircle}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="2" y="6" width="20" height="12" rx="2" ry="2"></rect>
            <circle cx="12" cy="12" r="2"></circle>
            <path d="M6 12h.01M18 12h.01"></path>
        </svg>
    </div>
)

const InfoIcon = () => (
    <div className={styles.iconCircle}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
    </div>
)

const ChartIcon = () => (
    <div className={styles.iconCircle}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="8 8 12 4 16 8"></polyline>
        </svg>
    </div>
)

const DocumentIcon = () => (
    <div className={styles.iconCircle}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="9" y1="13" x2="15" y2="13"></line>
            <line x1="9" y1="17" x2="15" y2="17"></line>
        </svg>
    </div>
)

interface EligibilityCriterion {
    icon: React.ReactNode
    title: string
    description: string
}

const EligibilitySection: React.FC = () => {
    const criteria: EligibilityCriterion[] = [
        {
            icon: <ServiceBadgeIcon />,
            title: 'Currently Serving or Veteran',
            description: 'You are or were a member of the Armed Forces.',
        },
        {
            icon: <FinanceIcon />,
            title: 'Took Out Finance While Serving',
            description: 'You obtained financial products during your service period.',
        },
        {
            icon: <InfoIcon />,
            title: 'Were Not Told About Commissions',
            description: "You weren't informed about commissions paid to brokers or dealers.",
        },
        {
            icon: <ChartIcon />,
            title: 'Did Not Know Your Rate Could Be Adjusted',
            description: "You weren't aware that interest rates could be adjusted.",
        },
        {
            icon: <DocumentIcon />,
            title: 'Terms Were Not Clearly Explained',
            description: 'The agreement terms were not adequately explained to you.',
        },
    ]

    return (
        <div className={`${styles.eligibilitySection} ${responsiveStyles.eligibilitySection}`}>
            <div className={styles.container}>
                <h2 className={styles.title}>Are You Eligible to Claim?</h2>
                <p className={styles.subtitle}>Armed forces personnel may have been mis-sold financial products. You could be eligible if any of the following apply:</p>

                <div className={`${styles.criteriaContainer} ${responsiveStyles.criteriaContainer}`}>
                    {criteria.map((criterion, index) => (
                        <div
                            key={index}
                            className={`
                                ${styles.criterionCard}
                                ${responsiveStyles.criterionCard}
                            `}
                        >
                            <div className={styles.iconContainer}>{criterion.icon}</div>
                            <h3 className={styles.criterionTitle}>{criterion.title}</h3>
                            <p className={styles.criterionDescription}>{criterion.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default EligibilitySection
